/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { createContext, useState } from "react";

export const DialogContext = createContext({});

const Dialog = ({ children }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [buttons, setButtons] = useState([]);

  const showDialog = ({ message, buttons }) => {
    setShow(true);
    setMessage(message);
    setButtons(buttons);
  };

  const hideDialog = () => {
    setShow(false);
    setMessage("");
    setButtons([]);
    setLoading(false);
  };

  const getTyleStyle = (button) => {
    if (button.type === "success") return { backgroundColor: "#20c366" };
    return {};
  };

  return (
    <DialogContext.Provider value={{ showDialog, hideDialog, setLoadingDialog: (e) => setLoading(e) }}>
      {children}
      {show ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,.5)",
            zIndex: 99,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              maxWidth: 325,
              backgroundColor: "#fff",
              borderRadius: 5,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: 30,
            }}
          >
            <div dangerouslySetInnerHTML={{ __html: message }} />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
                marginTop: 15,
                padding: "0 15px",
              }}
            >
              {buttons.map((button, index) => (
                <button
                  key={index}
                  onClick={loading ? null : button.onClick}
                  style={{
                    padding: 10,
                    margin: 3,
                    border: "none",
                    borderRadius: 3,
                    backgroundColor: "#555",
                    color: "#fff",
                    display: "flex",
                    flex: 1,
                    alignitems: "center",
                    justifyContent: "center",
                    ...getTyleStyle(button),
                  }}
                >
                  {loading && button.type === "success" ? "Loading" : button.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      ) : null}
    </DialogContext.Provider>
  );
};

export default Dialog;
